export const handleSortChange = (value, isCommodity) => {
    switch (value) {
        case 'position':
            if(isCommodity) {
                return {
                    sortBy: 'CommodityName',
                    sortDir: 'ASC'
                }
            } else {
                return {
                    sortBy: 'CountyName',
                    sortDir: 'ASC'
                }
            }
        case 'total-teus':
            return {
                sortBy: 'TotalTEUs',
                sortDir: 'DESC'
            }
        case 'total-tons':
            return {
                sortBy: 'TotalSTONS',
                sortDir: 'DESC'
            }
        case 'import-tons':
            return {
                sortBy: 'ImportSTONS',
                sortDir: 'DESC'
            }
        case 'export-tons':
            return {
                sortBy: 'ExportSTONS',
                sortDir: 'DESC'
            }
        case 'import-teus':
            return {
                sortBy: 'ImportTEUs',
                sortDir: 'DESC'
            }
        case 'export-teus':
            return {
                sortBy: 'ExportTEUs',
                sortDir: 'DESC'
            }
        default:
            if(isCommodity) {
                return {
                    sortBy: 'CommodityName',
                    sortDir: 'ASC'
                }
            } else {
                return {
                    sortBy: 'CountyName',
                    sortDir: 'ASC'
                }
            }
    }
}